/**
 * Material-UI overrides based on designs and pairing
 * We use the theme as a param to make the switch between dark and light easier
 * @param {*} theme - theme to be used as baseline
 */
export const componentOverrides = {
  MuiAlert: {
    defaultProps: {
      variant: 'outlined',
    },
  },
  MuiButton: {
    styleOverrides: {
      outlined: {
        backgroundColor: 'transparent',
      },
    },
  },
  MuiToggleButton: {
    styleOverrides: {
      sizeSmall: {
        // we want it square and matching material-ui spec
        padding: 7,
      },
    },
  },
  MuiLink: {
    defaultProps: {
      variant: 'inherit',
      underline: 'hover',
    },
  },
  MuiSlider: {
    styleOverrides: {
      markLabel: {
        top: 20,
      },
    },
  },
  MuiChip: {
    defaultProps: {
      size: 'small',
      shape: 'square',
      variant: 'light',
    },
    styleOverrides: {
      icon: ({theme}) => ({
        marginRight: theme.spacing(0.5),
        variants: [
          {
            props: ({ownerState}) => ownerState.label,
            style: {
              marginRight: theme.spacing(-0.5),
            },
          },
        ],
      }),
      label: ({theme}) => ({
        paddingRight: 0,
        paddingLeft: 0,
        variants: [
          {
            props: ({ownerState}) => ownerState.label,
            style: {
              paddingRight: theme.spacing(1),
            },
          },
          {
            props: ({ownerState}) => ownerState.label,
            style: {
              paddingLeft: theme.spacing(1),
            },
          },
        ],
      }),
    },
  },
  MuiSwitch: {
    styleOverrides: {
      root: {
        '& .MuiSwitch-switchBase.Mui-disabled+.MuiSwitch-track': {
          opacity: 1,
        },
      },
    },
  },
};
